module.exports = __webpack_public_path__ + "static/media/radianceDNAElixir.cda26922.png";